import { useState } from "react";
import { useParams, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  Users, 
  TrendingUp, 
  BookOpen, 
  Lightbulb, 
  Trophy,
  LayoutDashboard
} from "lucide-react";
import Dashboard from "@/components/Dashboard";
import AccountsView from "@/components/AccountsView";
import PipelineView from "@/components/PipelineView";
import ContentView from "@/components/ContentView";
import AdvisorView from "@/components/AdvisorView";
import GoalsView from "@/components/GoalsView";

const CommandModule = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    { label: "Command Module", path: "", icon: LayoutDashboard, color: "text-[#3dd9c5]" },
    { label: "Accounts", path: "accounts", icon: Users, color: "text-[#3dd9c5]" },
    { label: "Pipeline", path: "pipeline", icon: TrendingUp, color: "text-[#3dd9c5]" },
    { label: "Content", path: "content", icon: BookOpen, color: "text-[#3dd9c5]" },
    { label: "Advisor", path: "advisor", icon: Lightbulb, color: "text-[#3dd9c5]" },
    { label: "Goals", path: "goals", icon: Trophy, color: "text-[#3dd9c5]" }
  ];

  const currentPath = location.pathname.split('/').pop() || '';

  return (
    <div className="min-h-screen bg-[#0a0e17]">
      {/* Header with Navigation */}
      <header className="border-b border-gray-800/50 bg-[#0a0e17]/95 backdrop-blur-lg sticky top-0 z-50">
        <div className="container mx-auto px-6 py-3">
          <div className="flex items-center gap-6">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPath === item.path || (currentPath === '' && item.path === '');
              return (
                <Button
                  key={item.path}
                  onClick={() => navigate(`/dashboard/${userId}/${item.path}`)}
                  variant="ghost"
                  className={`${
                    isActive
                      ? 'bg-[#3dd9c5]/10 border-[#3dd9c5]/50 text-[#3dd9c5]'
                      : 'border-transparent text-gray-400 hover:text-white hover:bg-white/5'
                  } border transition-all`}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  <Icon className={`h-4 w-4 mr-2 ${isActive ? item.color : 'text-gray-400'}`} />
                  {item.label}
                </Button>
              );
            })}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="accounts" element={<AccountsView />} />
          <Route path="pipeline" element={<PipelineView />} />
          <Route path="content" element={<ContentView />} />
          <Route path="advisor" element={<AdvisorView />} />
          <Route path="goals" element={<GoalsView />} />
        </Routes>
      </div>

      {/* Footer */}
      <div className="text-center py-8 text-xs text-gray-600">
        © Copyright 2024 Intelligent Sales Machines, Inc. – All rights reserved.
      </div>
    </div>
  );
};

export default CommandModule;
